/**
 * Splash controller + page-transition overlay.
 *
 * - On every page load the splash COVERS the page from the first paint (CSS
 *   default), plays the Baldi animation, then slides UP to reveal the page.
 * - Internal link click: the splash slides DOWN to cover the CURRENT page first,
 *   then navigation happens under cover; the next page loads already covered
 *   (CSS default) and slides up to reveal it.
 *
 * The splash is left parked above the viewport after it lifts, so it can cover
 * again on the next navigation. Styles are inlined in snippets/splash.liquid.
 */
(function () {
  var DWELL_MS = 1500; // time covering, after the video is playable
  var TRANSITION_MS = 900; // matches the CSS transform transition
  var MAX_WAIT_MS = 5000; // exit even if the video never signals ready

  var splash = document.querySelector('.splash');
  if (!splash) return;

  var video = splash.querySelector('.splash__video');
  var layers = window.BaldiLayers;

  var navigating = false;
  var dwellStarted = false;

  function lock() {
    if (layers) layers.lock('splash');
  }
  function unlock() {
    if (layers) layers.unlock('splash');
  }
  function isCovering() {
    return !splash.classList.contains('splash--up');
  }

  lock(); // the splash covers the page on load (CSS default)

  splash.addEventListener('transitionend', function (event) {
    if (event.target !== splash || event.propertyName !== 'transform') return;
    // After the slide-UP reveal: leave parked above, restore scrolling.
    if (!navigating && !isCovering()) unlock();
  });

  function revealUp() {
    if (navigating || !isCovering()) return;
    splash.classList.add('splash--up'); // slides up to reveal the page
  }

  function startDwell() {
    if (dwellStarted || navigating) return;
    dwellStarted = true;
    window.setTimeout(revealUp, DWELL_MS);
  }

  // Begin the dwell as soon as the video is playable, so it's always seen.
  if (video) {
    if (video.readyState >= 3 /* HAVE_FUTURE_DATA */) {
      startDwell();
    } else {
      video.addEventListener('playing', startDwell, { once: true });
      video.addEventListener('canplay', startDwell, { once: true });
      video.addEventListener('error', startDwell, { once: true });
    }
  } else {
    startDwell();
  }

  window.setTimeout(revealUp, MAX_WAIT_MS);

  // A back/forward-cache restore (e.g. Safari Back) resumes this script's state
  // from when the page was left — possibly mid cover-then-navigate, with the
  // splash covering and scroll locked. Reset so the restored page is usable.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    navigating = false;
    splash.classList.add('splash--up');
    unlock();
  });

  // ----- Cover-then-navigate on internal links -----
  function coverThenNavigate(url) {
    if (navigating) return;
    navigating = true;
    lock();

    var done = false;
    function go() {
      if (done) return;
      done = true;
      window.location.href = url;
    }

    if (isCovering()) {
      window.setTimeout(go, 60); // already covering — go almost immediately
      return;
    }

    // Splash is parked above; slide it down to cover the current page.
    if (video) {
      try {
        video.currentTime = 0;
        video.play();
      } catch (e) {
        /* ignore autoplay restrictions */
      }
    }

    splash.addEventListener('transitionend', function onEnd(event) {
      if (event.target === splash && event.propertyName === 'transform') {
        splash.removeEventListener('transitionend', onEnd);
        go();
      }
    });
    splash.classList.remove('splash--up'); // slides down to cover (back to default)
    window.setTimeout(go, TRANSITION_MS + 200); // fallback if transitionend doesn't fire
  }

  document.addEventListener('click', function (event) {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }
    var link = event.target.closest ? event.target.closest('a[href]') : null;
    if (!link || link.target || link.hasAttribute('download')) return;
    if (link.protocol !== 'http:' && link.protocol !== 'https:') return;
    if (link.origin !== window.location.origin) return;
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;

    event.preventDefault();
    coverThenNavigate(link.href);
  });
})();
